import type { HasRuntimeOrigin } from '../types/dataEntitiesTabs.types';
import type { SystemRuntimeOrigin } from '../types/common.types';

export const getInternalDataEntities = <T extends HasRuntimeOrigin>(allSystems: T[]): T[] => {
  const origin: SystemRuntimeOrigin[] = ['system', 'replica', 'aggregator-storage-node'];

  return allSystems?.filter((system) => origin.includes(system.runtime.origin)) ?? [];
};
